import immutable from 'immutable'
import { LOGINCITY } from '../actiontype'
const defaultState = immutable.fromJS({
    // 城市列表
    cityData:[],
})

export const logincityReducer = (state = defaultState, action) => {
    switch (action.type) {
        case LOGINCITY:
            return state.updateIn(['cityData'], _ => (action.data))
        default:
            break;
    }
    return state
}
